import React, {useState, useRef, useEffect} from 'react';
import {useGoogleLogin} from '@react-oauth/google';
import {gapi} from 'gapi-script';
import './login.css';

const SSOLogin = ({history, ssoLogin}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showResendMsg, setResendMsgShow] = useState('show');
    const [roles, setRoles]= useState([])
    const [selectedRole, setSelectedRole] = useState('')

// If user is logged in automatically redirected to dashboard page
    useEffect(  () => {
        const token = !!window.localStorage.token;
        if (token === true && localStorage.getItem("token") !== undefined && localStorage.getItem("token") !== null && localStorage.getItem("token") !==''){
            history.push('/dashboard');
        }

        setTimeout(() => {
            setResendMsgShow('hide')
        }, 3000);
        const userRoles = window.localStorage.user_roles
        if(userRoles !== undefined && userRoles !== null && userRoles !== ''){
            let roleUserResponse = JSON.parse(userRoles)
            if (Object.keys(roleUserResponse).length > 0) {
                setRoles(roleUserResponse)
                if(roleUserResponse[0] !== undefined){
                    setSelectedRole(roleUserResponse[0]?.id)
                }
            }
        }
    }, []);

//   const clientId = '1088736098243-1249os37p8159hrbq7absbfjok307vfh.apps.googleusercontent.com'; // stage
    const clientId = "562755967467-0pkf2ivf7ivvkq86nqh6f4ikv150us03.apps.googleusercontent.com";
    useEffect(() => {
        if (gapi.client !== undefined) {
            const initClient = () => {
                gapi.client.init({
                    clientId: clientId,
                    scope: '',
                    cookiepolicy: 'single_host_origin',
                    flow: 'auth-code',
                    ux_mode : 'redirect',
                    redirect_uri: 'https://leadx.parkplus.io'
                });
            };
            gapi.load('client:auth2', initClient);
        }
    }, []);

    const googleLogin = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: async (codeResponse) => {
            console.log(codeResponse)
            setIsLoading(true);
            if (codeResponse?.code) {
                const response = await ssoLogin({
                    google_token:  codeResponse.code,
                    roleId:selectedRole,
                    package: "com.parviom.leadxweb",
                })
                console.log(response)
                setIsLoading(false);
                if (response.status === true) {
                    window.scrollTo(0, 0);
                    localStorage.setItem("token", response?.data?.token);
                    localStorage.setItem("refresh_token", response?.data?.refresh_token);
                    localStorage.setItem("name", response?.data?.name);
                    localStorage.setItem("user_id", response?.data?.id);
                    localStorage.setItem("active_page", 'home');
                    localStorage.setItem("role_id", selectedRole);
                    delete window.localStorage.user_roles
                    setTimeout(() => {
                        console.log('session start');
                    }, 1000);
                    if (response?.data?.token) {
                        window.localStorage.previous_url = JSON.stringify({0: window.location.href});
                        history.push('/home');
                    }
                }
            } else {
                setIsLoading(false);
            }

        },
        onError: errorResponse => console.log(errorResponse),
    });

    return (

        <div className="login-page-bg">
            <div className="wrapper mt-login-35">
                <div className="row justify-content-center">
                    <div className="col-xl-10 col-lg-12 col-md-9">
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">
                                <div className="row h-68vh">
                                    <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                                    <div className="col-lg-6">
                                        <div className="p-5">
                                            <div className="text-center">
                                                <img className="" src="./img/login_logo.png" alt=""/>
                                                <h2 id="blast" className="f-size colorful-text">LeadX</h2>
                                                {/*<h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>*/}

                                            </div>
                                            <form className="user" onSubmit={(e) => {e.preventDefault()}}>

                                                {roles.length > 1 &&
                                                    <div className="col-md-12">
                                                        <select className="select_role" onChange={(e) => {setSelectedRole(e.target.value)}} required>
                                                            <option value="" selected>Select Your Role</option>
                                                            {roles.map((val, i) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                }

                                                {roles.length === 1 &&
                                                    <div className="col-md-12">
                                                        <select className="select_role" onChange={(e) => {setSelectedRole(e.target.value)}} required>
                                                            {roles.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        {/*{setSelectedRole(val.id)}*/}
                                                                        <option value={val.id} selected>{val.name}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                }

                                                {/*<div className="col-md-12 l-2 text-center">*/}
                                                {/*    <span >OTP not received? <a href={"login-otp"} onClick={(e) => handleResentOtp(e)}>resend</a></span>*/}
                                                {/*</div>*/}

                                                <button type="submit" id=""
                                                        className="btn btn-primary btn-user btn-block" onClick={googleLogin}>
                                                    Log In
                                                </button>

                                            </form>
                                            <hr/>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>

    );
};


export default SSOLogin;